import { onINP } from 'web-vitals/attribution';
import type { INPMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';

const onInteractionToNextPaint = (report: (m: MetricReport) => void): void => {
  onINP((metric: INPMetricWithAttribution) => {
    const a = metric.attribution;
    report({
      name: 'interaction-to-next-paint',
      value: metric.value,
      unit: 'ms',
      rating: metric.rating,
      navigationType: metric.navigationType,
      id: metric.id,
      delta: metric.delta,
      attribution: {
        kind: 'inp',
        interactionTarget: a?.interactionTarget,
        interactionType: a?.interactionType,
        inputDelay: a?.inputDelay,
        processingDuration: a?.processingDuration,
        presentationDelay: a?.presentationDelay,
        loadState: a?.loadState,
        longestScriptDuration: a?.longestScript?.intersectingDuration,
        totalScriptDuration: a?.totalScriptDuration,
        totalStyleAndLayoutDuration: a?.totalStyleAndLayoutDuration,
      },
    });
  });
};

export default onInteractionToNextPaint;
